'use client';

import { Alert01Icon } from '@terra/ui-icons';
import { Alert } from '../../../components/alert';

export type InventoryInfoAlertProps = {
  message: string;
};

export function InventoryInfoAlert({ message }: InventoryInfoAlertProps) {
  return (
    <Alert.Root bg="bg.neutral.info" borderColor="border.neutral.info">
      <Alert.Icon asChild>
        <Alert01Icon size={16} />
      </Alert.Icon>
      <Alert.Content>
        <Alert.Description>{message}</Alert.Description>
      </Alert.Content>
    </Alert.Root>
  );
}
